import type { WritableDeep } from 'type-fest';

import { getDeepSection } from '../../utils/get-deep-section.util';
import type { Editable } from '../../types/editable.type';
import type { EnrichedSection } from '../../types/enriched-section.type';

import type { ReducerContext } from '../types/reducer-context.type';

import { updateCustomLayout } from './custom-layout.util';
import type { CustomLayoutUpdates } from './custom-layout.util';

interface ApplyLayoutUpdateToSectionTreeParams<E extends Editable> {
  readonly clonedEditable: WritableDeep<E>;
  readonly section: Readonly<EnrichedSection>;
  readonly updates: Partial<
    Pick<CustomLayoutUpdates, 'orientation' | 'paperFormat'>
  >;
  readonly context: ReducerContext<E>;
}

export const applyLayoutUpdateToSectionTree = <E extends Editable>({
  clonedEditable,
  section,
  updates,
  context,
}: Readonly<ApplyLayoutUpdateToSectionTreeParams<E>>): void => {
  if (section.insertionPoint) {
    updateCustomLayout({
      clonedEditable,
      insertionPointRealPath: section.insertionPoint.realPath,
      sectionId: section._id,
      updates,
      context,
    });
  } else {
    Object.assign(
      getDeepSection(
        context.getEditable<true>(clonedEditable).virtualRoot,
        section.realPath,
      ),
      updates,
    );
  }

  section.subSections.forEach((subSection) => {
    applyLayoutUpdateToSectionTree({
      clonedEditable,
      section: subSection,
      updates,
      context,
    });
  });
};
